import colors from '../../themes/colors';
export var getBannerColors = function (variant) {
    return ({
        error: {
            borderColor: colors.red60,
            backgroundColor: colors.red0
        },
        warning: {
            borderColor: colors.yellow50,
            backgroundColor: colors.yellow5
        },
        info: {
            borderColor: colors.neutral20,
            backgroundColor: colors.neutral0
        },
        success: {
            borderColor: colors.green60,
            backgroundColor: colors.proximaGreen5
        }
    }[variant]);
};
